
import * as AlisonJS from 'AlisonJS';
export default (function () {

    _alisonDesktop: null;

    return {
        version: AlisonJS.default.version,
        desktopVersion: function(){
            return this._alisonDesktop.version;
        },
        createInstance: function(urls, timeout){
            this._alisonDesktop = new AlisonJS.Desktop(urls, timeout);
            console.log(AlisonJS.SignFormat, "SIGN");
        },
        getServerSignFormats() {
            return AlisonJS.SignFormat
        },
        isEnabled: function(){
            return this._alisonDesktop.isEnabled();
        },
        isRunning: function(){
            return this._alisonDesktop.isRunning();
        },
        enable: function(){
            return this._alisonDesktop.enable();
        },
        initialize: function(accessToken, timeout){
            return this._alisonDesktop.initialize(accessToken, timeout)
        },
        listKeyStores: function() {
            return this._alisonDesktop.listKeyStores()
        },
        listProfiles: function() {
            return this._alisonDesktop.listProfiles()
        },
        keyStoreInfo: function(keystoreId) {
            return this._alisonDesktop.keyStoreInfo(keystoreId)
        },
        generateCsr: function(config){
            return this._alisonDesktop.generateCsr(config)
        },
        initializeProfile: function(params){
            return this._alisonDesktop.initializeProfile(params)
        },
        installPkcs7: function(objInstall){
            return this._alisonDesktop.installPkcs7(objInstall)
        },
        importCertificate: function(objImport){
            return this._alisonDesktop.importCertificate(objImport)
        },
        certificateList: function(){
            return this._alisonDesktop.certificateList()
        },
        sign: function(args){
            return this._alisonDesktop.sign(args)
        },
        getSignature: function(args){
            return this._alisonDesktop.getSignature(args)
        },
        getSignatures: function(args){
            return this._alisonDesktop.getSignatures(args)
        }
    }
})();
